module.exports = __webpack_public_path__ + "static/media/bioPhoto.8997ee14.jpg";